import { Component, OnInit } from '@angular/core';
import { CommonModule } from "@angular/common";

// Material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// RxJs
import { Observable } from 'rxjs';

// NgRX
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../core/store/reducers';
import { selectNetworkLoadingState } from '../../../core/store/selectors/network.selectors';




@Component({
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  selector: 'rental-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderSComponent implements OnInit {

  public isLoading$!: Observable<boolean>;

  constructor(private readonly store: Store<AppState>) {
    this.isLoading$ = this.store.select(selectNetworkLoadingState)
  }

  ngOnInit(): void { }
}
